function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Menu } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Icon } from "@iconify/react";
import { Power, HouseFill, Image, CapsulePill, Activity, CalendarWeekFill, Calendar3, ClockHistory, BuildingFill, CashStack, BinocularsFill, PersonCheck, AwardFill, PersonLinesFill, LungsFill, PersonVcardFill, Speedometer, Clipboard2PulseFill, Building, CheckCircleFill, PieChartFill, PeopleFill, GearFill, EarFill, EyeFill, HeartPulseFill, Eyedropper } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;
var UserNavBar = function UserNavBar(_ref) {
  var handleMenuClose = _ref.handleMenuClose;
  var navigate = useNavigate();
  var _useState = useState(localStorage.getItem("currentKey")),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
    localStorage.setItem("currentKey", e.key);
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
  };
  var user = Common.currentUser;
  return /*#__PURE__*/_jsxs(Menu, {
    theme: "dark",
    style: {
      background: "#19375D"
    },
    onClick: handleClick,
    selectedKeys: current,
    mode: "vertical",
    children: [(Common.currentUser.role == 901 || Common.currentUser.role == 101) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Speedometer, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/dashboard",
        children: /*#__PURE__*/_jsx("b", {
          children: "R\xE9sum\xE9"
        })
      })
    }, "dash"), (Common.currentUser.role == 1 || Common.currentUser.role == 10 || Common.currentUser.role == 101 || Common.currentUser.role == 102 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/cashier",
        children: /*#__PURE__*/_jsx("b", {
          children: "Candidats"
        })
      })
    }, "cashier"), (Common.currentUser.role == 2 || Common.currentUser.role == 21 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Eyedropper, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/laboratoire",
        children: /*#__PURE__*/_jsx("b", {
          children: "Laboratoire"
        })
      })
    }, "lab"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 4 || Common.currentUser.role == 5 || Common.currentUser.role == 6 || Common.currentUser.role == 10 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(BinocularsFill, {
        size: 28
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Exploration"
      }),
      children: [(Common.currentUser.role == 3 || Common.currentUser.role == 5 || Common.currentUser.role == 6 || Common.currentUser.role == 10 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(EarFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/audio",
          children: /*#__PURE__*/_jsx("b", {
            children: "AudioTest"
          })
        })
      }, "audio"), (Common.currentUser.role == 3 || Common.currentUser.role == 4 || Common.currentUser.role == 6 || Common.currentUser.role == 10 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(EyeFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/visio",
          children: /*#__PURE__*/_jsx("b", {
            children: "VisioTest"
          })
        })
      }, "visio"), (Common.currentUser.role == 3 || Common.currentUser.role == 6 || Common.currentUser.role == 10 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(LungsFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/spiro",
          children: /*#__PURE__*/_jsx("b", {
            children: "Spirometrie"
          })
        })
      }, "spiro")]
    }, "exp"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Clipboard2PulseFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/consultations",
        children: /*#__PURE__*/_jsx("b", {
          children: "Examen"
        })
      })
    }, "qmed"), (Common.currentUser.role == 8 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Image, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/imagerie",
        children: /*#__PURE__*/_jsx("b", {
          children: "Radio"
        })
      })
    }, "im"), (Common.currentUser.role == 3 || Common.currentUser.role == 10 || Common.currentUser.role == 31 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PersonCheck, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/vaccin",
        children: /*#__PURE__*/_jsx("b", {
          children: "Vaccination"
        })
      })
    }, "vaccin"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 10 || Common.currentUser.role == 901 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HeartPulseFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/ecg",
        children: /*#__PURE__*/_jsx("b", {
          children: "ECG"
        })
      })
    }, "ecg"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 901 || Common.currentUser.role == 102) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(Activity, {
        size: 28
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Traitement"
      }),
      children: [(Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 901 || Common.currentUser.role == 102) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(AwardFill, {
          style: {
            color: "#FFFFFF"
          },
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/conclusion",
          children: /*#__PURE__*/_jsx("b", {
            children: "Dossiers M\xE9dicaux"
          })
        })
      }, "cert"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 901 || Common.currentUser.role == 102) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(ClockHistory, {
          style: {
            color: "#FFFFFF"
          },
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/validated",
          children: /*#__PURE__*/_jsx("b", {
            children: "Dossiers Valid\xE9s"
          })
        })
      }, "valid"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(CheckCircleFill, {
          style: {
            color: "#FFFFFF"
          },
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/history",
          children: /*#__PURE__*/_jsx("b", {
            children: "Historiques Candidats"
          })
        })
      }, "history"), (Common.currentUser.role == 3 || Common.currentUser.role == 31 || Common.currentUser.role == 901 || Common.currentUser.role == 102) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(PersonVcardFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/evolution",
          children: /*#__PURE__*/_jsx("b", {
            children: "Circuit"
          })
        })
      }, "ev")]
    }, "process"), (Common.currentUser.role == 10 || Common.currentUser.role == 101 || Common.currentUser.role == 102 || Common.currentUser.role == 901) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(BuildingFill, {
        size: 28
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: " Administration"
      }),
      children: [(Common.currentUser.role == 10 || Common.currentUser.role == 102 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(CalendarWeekFill, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/appointments",
          children: /*#__PURE__*/_jsx("b", {
            children: "Rendez-vous"
          })
        })
      }, "appoint"), (Common.currentUser.role == 10 || Common.currentUser.role == 102 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Building, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/companies",
          children: /*#__PURE__*/_jsx("b", {
            children: "Soci\xE9t\xE9s"
          })
        })
      }, "comps"), (Common.currentUser.role == 10 || Common.currentUser.role == 102 || Common.currentUser.role == 101 || Common.currentUser.role == 901) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Calendar3, {
          size: 22
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/vaplanning",
          children: /*#__PURE__*/_jsx("b", {
            children: "PLAN V. AN"
          })
        })
      }, "pva")]
    }, "adm"), Common.currentUser.role == 901 && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PeopleFill, {
        style: {
          color: 'FBB91D'
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/users",
        children: /*#__PURE__*/_jsx("b", {
          children: "Utilisateurs"
        })
      })
    }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(GearFill, {
        style: {
          color: 'FBB91D'
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/accountconfig",
        children: /*#__PURE__*/_jsx("b", {
          children: " Mon Compte"
        })
      })
    }, "accountconfig"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Power, {
        style: {
          color: '#B7403F'
        },
        size: 26
      })
    }, "quit")]
  });
};
export default UserNavBar;